import { jsx as _jsx } from "react/jsx-runtime";
import { useEffect, useState } from 'react';
import { RichTextEditorEvents } from './types';
import { Logger } from '../../../../infra/observability/logger';
import { t } from '../../../../infra/i18n';
export var Limit = function (_a) {
    var editorRef = _a.editorRef;
    var _b = useState(0), count = _b[0], setCount = _b[1];
    var _c = useState(undefined), limit = _c[0], setLimit = _c[1];
    useEffect(function () {
        if (!editorRef || !editorRef.current)
            return;
        setCount(editorRef.current.getCharacterCount());
        setLimit(editorRef.current.getCharacterLimit());
        var handleUpdate = function (e) {
            var event = e;
            if (event.detail.id === editorRef.current.getEditorId()) {
                setCount(event.detail.count);
                setLimit(event.detail.limit);
            }
        };
        document.addEventListener(RichTextEditorEvents.UPDATE_COUNT, handleUpdate);
        // eslint-disable-next-line consistent-return
        return function () {
            document.removeEventListener(RichTextEditorEvents.UPDATE_COUNT, handleUpdate);
        };
    }, [editorRef]);
    if (!editorRef || !editorRef.current) {
        Logger.error('Editor limit component crashed', {
            error: 'Editor ref is not provided or not initialized',
            editorRef: JSON.stringify(editorRef),
            action: 'Editor limit component crashed',
        });
        return null;
    }
    if (limit === undefined || limit === null)
        return null;
    return _jsx("div", { children: t('engage:rich_text_editor.characters_left', { count: limit - count }) });
};
